import { reducer as addressReducer } from 'feature/addresses/redux/AddressSlice'
import { companyAddressReducer } from 'feature/addresses/redux/CompanyAddressSlice'
import { myAddressesApi } from 'feature/addresses/redux/MyAddresses.api'
import { reducer as appealFormReducer } from 'feature/appeals/redux/AppealFormSlice'
import { appealApi } from 'feature/appeals/redux/appeals.api'
import { reducer as appealReducer } from 'feature/appeals/redux/EditableAppealSlice'
import { reducer as authReducer } from 'feature/auth/redux/authSlice'
import { noticeApi } from 'feature/notifications/redux/noticeApi'
import { reducer as orderFormSlice } from 'feature/productOrder/redux/orderFormSlice'
import { ordersApi } from 'feature/productOrder/redux/orders.api'
import { screenModeReducer } from 'feature/screenMode'
import { servicesApi } from 'feature/serviceCenters/redux/service.api'
import { registrationApi } from 'feature/registration/api/registrationLkmApi'
import { reducer as serviceReducer } from 'feature/serviceCenters/redux/ServiceCentersSlice'
import { userApi } from 'feature/user/redux/user.api'
import { reducer as yandexMapReducer } from 'feature/YandexMap/redux/YandexMapSlice'
import noticeReducer from 'widget/Notifications/store'
import { fitterApi } from 'feature/user/redux/fitter.api'
import { lkmAppealsApi } from 'feature/lkmAppeals/redux/LkmAppeals.api'
import { companyReducer } from 'feature/company/redux/companySlice'
import { companyApi } from 'feature/company/redux/company.api'

export const reducer = {
  // авторизация и доп инфа пользователя
  auth: authReducer,
  // текущий экран устройства
  screenMode: screenModeReducer,
  // уведомления
  notice: noticeReducer,
  // контроль яндекс карты (метки, контроллеры и т.п.)
  yandexMap: yandexMapReducer,
  // серверные центры (доп данные)
  services: serviceReducer,
  // работа с выбранным адресам (его валидация и т.п)
  address: addressReducer,
  // адрес компании (независимый от основного адресного слайса)
  companyAddress: companyAddressReducer,
  newAppeal: appealReducer,
  stateCurrentAppeal: appealFormReducer,
  // хранения данных форм заявки
  orderForm: orderFormSlice,
  // данные компании (для юридических лиц)
  company: companyReducer,
  // API для работы с данными пользователя
  [userApi.reducerPath]: userApi.reducer,
  // API для работы с серверными центрами
  [servicesApi.reducerPath]: servicesApi.reducer,
  // API для работы с адресами пользователя
  [myAddressesApi.reducerPath]: myAddressesApi.reducer,
  [appealApi.reducerPath]: appealApi.reducer,
  // API для работы с заявками
  [ordersApi.reducerPath]: ordersApi.reducer,
  // API для работы с уведомлениями
  [noticeApi.reducerPath]: noticeApi.reducer,
  [registrationApi.reducerPath]: registrationApi.reducer,
  [fitterApi.reducerPath]: fitterApi.reducer,
  [lkmAppealsApi.reducerPath]: lkmAppealsApi.reducer,
  // API для работы с компаниями (юридическими лицами)
  [companyApi.reducerPath]: companyApi.reducer,
}
